module.exports = "<div class=\"config\"><div class=\"filter-prop-tab\"><sc-speech-recognition-config config=\"$ctrl.config\" errors=\"$ctrl.errors\"></sc-speech-recognition-config></div></div><div class=\"results\"><sc-speech-recognition-results filter=\"filter\"></sc-speech-recognition-results><sc-speech-recognition-stats filter=\"filter\"></sc-speech-recognition-stats></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/editor/tabs/speech-recognition-tab.component.html
// module id = 337
// module chunks = 0